import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Switch } from "@/components/ui/switch";
import { staffApi, errMsg } from "@/lib/api";
import { loadDisplay } from "@/lib/display";

export const DevotionalSwitch = () => {
  const [d, setD] = useState(null);
  useEffect(() => { loadDisplay(true).then(setD); }, []);
  if (!d?.communities) return null;
  const on = d.devotionals_enabled !== false;
  const toggle = async (v) => {
    try {
      const r = await staffApi().put("/display-settings", { ...d, devotionals_enabled: v });
      setD(r.data); await loadDisplay(true);
      toast.success(v ? "2-Minute Devotionals are now showing on the website" : "2-Minute Devotionals are now hidden from the website");
    } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className={`flex items-center justify-between gap-4 rounded-3xl border p-5 ${on ? "border-emerald-200 bg-emerald-50" : "border-slate-200 bg-white"}`} data-testid="devotional-switch-card">
      <div>
        <p className="font-semibold text-slate-900">2-Minute Devotional on the website</p>
        <p className="text-sm text-slate-500" data-testid="devotional-switch-status">{on ? "On — showing on the home page, pop-up, Devotionals page and links." : "Off — hidden everywhere on the public website. Uploads and approvals still work here."}</p>
      </div>
      <Switch checked={on} onCheckedChange={toggle} data-testid="devotional-switch" />
    </div>
  );
};
